import { FC } from 'react';
import styled from 'styled-components';

import { useIwEditingStore } from '@/entities/interwills/stores/iwEditing.store';
import { useMnemonicPhraseStore } from '@/entities/mnemonic';
import { useCollectionsStatusStore } from '@/shared/lib/sj-orm/stores/collectionsStatus.store';
import { useAuthStore } from '@/shared/store/auth.store';
import { useCryptoStore } from '@/shared/store/crypto.store';
import { useKeyPairStore } from '@/shared/store/decrypted-keypair.store';

export const TabStores: FC = () => {
  const authStore = useAuthStore();
  const keyPairStore = useKeyPairStore();
  const cryptoStore = useCryptoStore();
  const mnemonicStore = useMnemonicPhraseStore();
  const colStatusStore = useCollectionsStatusStore();
  const iwEditing = useIwEditingStore();

  const list: Record<string, object> = {
    keyPairStore,
    cryptoStore,
    authStore,
    colStatusStore,
    mnemonicStore,
    iwEditing,
  };

  return (
    <Container>
      {Object.entries(list).map(([name, iStore], index) => (
        <StoreValues name={name} store={iStore} key={index} />
      ))}
    </Container>
  );
};

const StoreValues: FC<{ name: string; store: object }> = ({ name, store }) => {
  const entries = Object.entries(store).filter(([, value]) => typeof value !== 'function');

  return (
    <StoreValuesContainer>
      <b>{name}</b>
      {entries.map(([key, value], index) => (
        <Entry key={index}>
          <EntryName>{key}</EntryName>
          <EntryValue>
            {value && typeof value === 'object' ? JSON.stringify(value) : String(value)}
          </EntryValue>
        </Entry>
      ))}
    </StoreValuesContainer>
  );
};

const Container = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  @media screen and (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

const StoreValuesContainer = styled.div`
  max-height: 180px;
  padding: 4px 8px 8px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow: hidden auto;
`;

const Entry = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const EntryName = styled.div`
  width: 100px;
  flex-shrink: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  &&&:hover {
    width: auto;
    min-width: 100px;
  }
`;

const EntryValue = styled.div`
  white-space: nowrap;
`;
